import { shallowEqual, useSelector } from 'react-redux';
import { IStore } from 'store/interface';
import { getInventoryElement } from '../../selector';
import { IInventoryElement } from '../../interfaces';

export const useInventoryElements = (id: string) => ({
  item: useSelector<IStore, IInventoryElement>(getInventoryElement(id), shallowEqual),
});
